<template>
  <div class="vx-card" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <h1 class="card-bg p-6 text-center mt-4">SATIŞ GÜNCELLEME YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchSaleOrder = !showSearchSaleOrder">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6" /></span><span>Satış Arama</span>
        </h2>

        <div v-if="showSearchSaleOrder" class="card-bg p-5">
          <form @submit.prevent="getSaleOrder()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Satış Id</b></label>
                <vs-input type="text" style="width: 100%;" v-model="saleOrderSearch.orderId" placeholder="Satış Id" />
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Satışlar</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="saleOrderList">
            <template slot="thead">
              <vs-th>Satış Id</vs-th>
              <vs-th>Müşteri</vs-th>
              <vs-th>Döviz Türü</vs-th>
              <vs-th>KDV Dahil</vs-th>
              <vs-th>Tam Fatura</vs-th>
              <vs-th>İşlem</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <template v-if="tr.orderId">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 10%;">
                    <b> {{ tr.orderId }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <b> {{ tr.customer }}</b>
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <v-select style="width: 200px;" name="Id" v-model="tr.currencyId" :options="moneyCurrencyOptions" label="name" :reduce="(row) => row.id"> </v-select>
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <vs-switch size="small" v-model="tr.taxIncluded" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <vs-switch size="small" v-model="tr.isFullInvoice" />
                  </vs-td>
                  <vs-td style="width: 10%;">
                    <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveSaleOrder(tr, 'Update', '')" />
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Satış Detayları</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="saleOrderLineList">
            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>Satış Id</vs-th>
              <vs-th>Ürün Id</vs-th>
              <vs-th>Ürün</vs-th>
              <vs-th>Depo</vs-th>
              <vs-th>İşlem</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <template v-if="tr.id">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 10%;">
                    <b> {{ tr.id }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 10%;">
                    <b> {{ tr.orderId }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <vs-input type="number" v-model="tr.productId" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <b> {{ tr.productName }}</b>
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <v-select style="width: 200px;" name="Id" v-model="tr.warehouseId" :options="warehouseList" label="value" :reduce="(row) => row.id"> </v-select>
                  </vs-td>
                  <vs-td style="width: 10%;">
                    <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveSaleOrderLine(tr, 'Update', '')" />
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      saleOrderItem: { orderId: null, currency: null, taxIncluded: null, isFullInvoice: null },
      saleOrderLineItem: { orderId: null, productId: null, warehouseId: null },
      saleOrderList: [],
      saleOrderLineList: [],
      moneyCurrencyOptions: [],
      saleOrderSearch: { orderId: null },
      warehouseList: [],
      warehouseSearch: { id: null, value: null },
      showSearchSaleOrder: false,
    };
  },

  computed: {},
  methods: {
    getSaleOrder: async function () {
      if (this.saleOrderSearch.orderId) {
        this.$vs.loading();
        this.saleOrderList = await repository.postEntity("ParametricScreens/GetSaleOrderUpdate", this.saleOrderSearch).then((r) => r.list);
        await this.getSaleOrderLine();
        this.$vs.loading.close();
      }
    },
    getCurrencies: async function () {
      this.moneyCurrencyOptions = await repository.getAll("Accounting/getCurrencies").then((r) => r.list);
    },

    SaveSaleOrder: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ParametricScreens/SaveSaleOrder", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });
      this.saleOrderItem = {};
      this.saleOrderSearch = {};
      this.getSaleOrder();
    },
    SaveSaleOrderLine: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ParametricScreens/SaveSaleOrderLine", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.saleOrderLineItem = {};
    },
    getSaleOrderLine: async function () {
      this.saleOrderLineList = await repository.postEntity("ParametricScreens/GetSaleOrderLineUpdate", this.saleOrderSearch).then((r) => r.list);
    },
    getWarehouse: async function () {
      this.$vs.loading();
      this.warehouseList = await repository.postEntity("ParametricScreens/getWarehouse", this.warehouseSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getSaleOrder(), this.getCurrencies(), this.getWarehouse()]);
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1366px !important;
  max-height: 95% !important;
}
</style>
